<form [formGroup]="form" class="date-group">
    <h4 style="margin-bottom: 2px; color: #5b5b5b"> {{ label | translate | capitalizeFirst }}:</h4>
    <div class="order-time-container">
        <mat-form-field appearance="outline" style="width: 45%;">
            <mat-label> {{'snvr.vehicle-recordings.ordered-time-range-start' | translate | capitalizeFirst }}:</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="start" onchange="onSelectChange()">
            <mat-datepicker-toggle *ngIf="!form.value.start" matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <button *ngIf="form.value.start" mat-icon-button matSuffix type="button" aria-label="Clear selection"
                (click)="form.get('start')?.setValue(null); $event.stopPropagation()" [disabled]="form.disabled">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 45%;">
            <mat-label> {{'snvr.vehicle-recordings.ordered-time-range-end' | translate | capitalizeFirst }}</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="end" onchange="onSelectChange()">
            <mat-datepicker-toggle *ngIf="!form.value.end" matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <button *ngIf="form.value.end" mat-icon-button matSuffix type="button" aria-label="Clear selection"
                (click)="form.get('end')?.setValue(null); $event.stopPropagation()" [disabled]="form.disabled">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </mat-form-field>
    </div>
    <mat-error [style.visibility]="form.invalid ? 'visible' : 'hidden'">
        {{'snvr.vehicle-recordings.ordered-time-range-error' | translate | capitalizeFirst }}</mat-error>
</form>